import React from 'react';
import { Table } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { skeletonObj } from './PropsCards';
import classNames from 'classnames';

const PropsTable = ({
  data,
  columns,
  filtersAndSort,
  setFiltersAndSort,
  propsLimit,
  loading
}) => {
  const skeletonArr = Array(propsLimit).fill(skeletonObj);

  return (
    <Table
      className={classNames(
        'fs--1 mb-0 border-light table table-striped table-bordered bg-white rounded-3',
        {
          'loading-skeleton': loading
        }
      )}
    >
      <thead className="bg-200 text-nowrap align-middle">
        <tr key={'head_tr'}>
          {columns &&
            columns.map(col => {
              return (
                <th
                  key={col.accessor}
                  role="columnheader"
                  colSpan="1"
                  scope="col"
                  title={col.headerProps.title}
                  className="py-2"
                >
                  {col.Header}
                  {col.canSort && (
                    <span
                      key={`span_${col.accesor}`}
                      onClick={() =>
                        setFiltersAndSort({
                          ...filtersAndSort,
                          sortBy: {
                            order:
                              filtersAndSort.sortBy.prop === col.accessor
                                ? filtersAndSort.sortBy.order === 'asc'
                                  ? 'desc'
                                  : 'asc'
                                : 'asc',
                            prop: col.accessor
                          }
                        })
                      }
                      className={
                        filtersAndSort.sortBy.prop === col.accessor
                          ? filtersAndSort.sortBy.order === 'asc'
                            ? 'sort asc'
                            : 'sort desc'
                          : 'sort'
                      }
                      style={{ cursor: col.canSort ? 'pointer' : 'default' }}
                    />
                  )}
                </th>
              );
            })}
        </tr>
      </thead>
      <tbody>
        {!loading
          ? data &&
            data.map(row => {
              return (
                <tr key={`tr_${row.id}`} className="align-middle">
                  {columns &&
                    columns.map((col, i) => (
                      <td
                        key={`${col.accessor}_${row.id}`}
                        className="text-dark py-1"
                        scope={i === 0 ? 'row' : null}
                      >
                        {col.Cell ? col.Cell(row) : row[col.accessor]}
                      </td>
                    ))}
                </tr>
              );
            })
          : skeletonArr.map((row, i) => {
              return (
                <tr key={`tr_${i}`} className="align-middle">
                  {columns &&
                    columns.map((col, i) => (
                      <td
                        key={`${col.accessor}_${i}`}
                        className="text-dark py-1"
                        scope={i === 0 ? 'row' : null}
                      >
                        <p className="m-0">{row[col.accessor]}</p>
                      </td>
                    ))}
                </tr>
              );
            })}
      </tbody>
    </Table>
  );
};

PropsTable.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  filtersAndSort: PropTypes.object.isRequired,
  setFiltersAndSort: PropTypes.func.isRequired,
  propsLimit: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired
};

export default PropsTable;
